/**
 * Breakpoint für die Komponente Mobile <-> Desktop
 */
export const ELEMENT_BREAKPOINT = 800;
